exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_birthdayContainer_2vCE7HIKk1q57kYajqg6e9{\n  width: 100%;\n  display: inline-block;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_birthdayContainer": "IA_birthdayContainer_2vCE7HIKk1q57kYajqg6e9"
};